<template>
  <div class="form-group" :class="{ 'input-group-sm': small }">
    <label for="input_elem" v-if="caption">{{ caption }}</label>
    <textarea 
      v-if="type === 'textarea'"
      class="form-control" 
      v-model.trim="inputData"
      :class="{ 'is-invalid' : (isError || classError) && !success, 'is-valid': success && !isError }"
      :style="'background-color: ' + bgColor + ';'"
      @input="onInput"
      :disabled="disabled"
      :placeholder="placeholder">
    </textarea>
    <div class="datepicker" v-else-if="type === 'datepicker'" :class="{ 'input-group-sm': small }"> <!-- datepicker -->
      <input 
        type="text" 
        class="form-control" 
        v-model.trim="date"
        :class="{ 'is-invalid' : (isError || classError) && !success, 'is-valid': success && !isError }"
        :style="'background-color: ' + bgColor + ';'"
        @keydown="(e) => { return checkKey(e)}"
        @change="emitDate()"
        :disabled="disabled"
        :placeholder="placeholder" 
        @click="showCalendar = false"
      />
      <div class="ico-calendar" @click="openCalendar"> 
        <svg class="bi bi-calendar-check" width="1em" height="1em" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" d="M10.854 7.146a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L7.5 9.793l2.646-2.647a.5.5 0 0 1 .708 0z"/>
          <path fill-rule="evenodd" d="M1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4H1zm1-3a2 2 0 0 0-2 2v11a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2H2z"/>
          <path fill-rule="evenodd" d="M3.5 0a.5.5 0 0 1 .5.5V1a.5.5 0 0 1-1 0V.5a.5.5 0 0 1 .5-.5zm9 0a.5.5 0 0 1 .5.5V1a.5.5 0 0 1-1 0V.5a.5.5 0 0 1 .5-.5z"/>
        </svg>
      </div>
      <div class="calendar" v-if="showCalendar">
        <div class="year d-flex justify-content-center">
          <input 
            type="number" 
            value="2020" 
            min="1900" 
            max="2100" 
            v-model="year" 
            @change="inputYear" 
            @input="checkLengthYear"
          />год
        </div>
        <div class="month d-flex justify-content-between">
          <input type="button" value="<" class="left info" title="показать предыдущий месяц" @click="changeMonth(-1)">
          <h5 class="info">{{ getNameMonth }}</h5>
          <input type="button" value=">" class="right info" title="показать следующий месяц" @click="changeMonth(1)">
        </div>
        <div class="d-flex justify-content-between day">
          <span class="day">пн</span>
          <span class="day">вт</span>
          <span class="day">ср</span>
          <span class="day">чт</span>
          <span class="day">пт</span>
          <span class="day">сб</span>
          <span class="day">вс</span>
        </div>
        <div class="d-flex justify-content-between">
          <span class="day" v-for="day of 7" :key="day + 'day1'" @click="clickDay($event)">
            {{ (day >= getFirstDay) ? day+1-getFirstDay : '' }}
          </span>
        </div>
        <div v-for="week of getCountWeeks-1" :key="week + 'week'" class="d-flex justify-content-between"> 
          <span class="day" v-for="day of 7" :key="day + 'day'" @click="clickDay($event)">
            {{ getDateDay(week, day) }}
          </span>
        </div>
      </div>
    </div>
    <input 
      v-else
      :type="type" 
      class="form-control" 
      v-model.trim="inputData"
      :class="{ 'is-invalid' : (isError || classError) && !success, 'is-valid': success && !isError }"
      :style="'background-color: ' + bgColor + ';' + (upperCase ? 'text-transform: uppercase;' : '')"
      @input="onInput"
      :disabled="disabled"
      :placeholder="placeholder" 
    /> <!-- input -->
    <small class="form-text text-danger" v-if="isError">{{ textError }}</small>
    <small class="form-text text-info" v-else-if="maxLength > 0 && !hideTextLength">{{ inputData.length }} / {{ maxLength }}</small>
  </div>
</template>

<script>
  // component: Inputin
  // version: 0.0.3
  // date: 06.2020
  // sagit117@gmail.com 
export default {
  props: {
    type: String,
    isError: Boolean,
    textError: String,
    caption: String,
    maxLength: Number,
    success: Boolean,
    small: Boolean,
    bgColor: String,
    disabled: Boolean,
    value: String,
    placeholder: String,
    hideTextLength: Boolean,
    upperCase: {
        type: Boolean,
        default: false,
    }
  },
  data() {
    return {
      inputData: '',
      classError: false,
      date: '',
      showCalendar: false,
      year: new Date().getFullYear(),
      month: new Date().getMonth(),
    }
  },
  mounted() {
    this.setValue()
  },
  watch: {
    value: function() {
      this.setValue()
    },
  },
  computed: {
    getNameMonth: function() {
      const month = [
        'Январь',
        'Февраль',
        'Март',
        'Апрель',
        'Май',
        'Июнь',
        'Июль',
        'Август',
        'Сентябрь',
        'Октябрь',
        'Ноябрь',
        'Декабрь'
      ]
      return month[this.month]
    },
    dayInMonth: function() {
      return 33 - new Date(this.year, this.month, 33).getDate()
    },
    getFirstDay: function() {
      const day = new Date(this.year, this.month, 1).getDay()
      return (day === 0) ? 7 : day
    },
    getCountWeeks: function() {
      const l = new Date(this.year, this.month+1, 0)
      return Math.ceil((l.getDate() - (l.getDay() ? l.getDay() : 7)) / 7) + 1
    }
  },
  methods: {
    onInput() {
      if (this.maxLength > 0 && this.inputData.length > this.maxLength) this.inputData = this.inputData.slice(0, this.maxLength)
      this.$emit("on-input", this.inputData)
    },
    checkKey(e) { // проверка нажатия кнопок для даты
      if (e.key >= 0 && e.key <= 9 || e.key === 'Backspace') {
        if (this.date.length === 2 && e.key !== 'Backspace') this.date += "."
        if (this.date.length === 5 && e.key !== 'Backspace') this.date += "."
        if (this.date.length === 10 && e.key !== 'Backspace') e.preventDefault()
        return e.key
      } else {
        e.preventDefault()       
      }
    },
    openCalendar() {
      if (this.disabled) return

      this.showCalendar = !this.showCalendar
      
      if (this.showCalendar) {
        const date = new Date(String(this.date).split('.')[2], String(this.date).split('.')[1]-1, String(this.date).split('.')[0])

        if (date.getFullYear() > 1900 && date.getFullYear() < 2100) {
          this.year = date.getFullYear()
          this.month = date.getMonth()
        } else {
          this.year = new Date().getFullYear()
          this.month = new Date().getMonth()
        }
      }
    },
    inputYear() {
      this.year = parseInt(this.year)
      if (!this.year) this.year = new Date().getFullYear()
      if (this.year.length < 4) this.year = 1900
      if (this.year < 1900) this.year = 1900
      if (this.year.length > 4) this.year = 2100
      if (this.year > 2100) this.year = 2100
    },
    changeMonth(pay) {
      this.month += pay
      if (this.month < 0) this.month = 11
      if (this.month > 11) this.month = 0
    },
    getDateDay(week, day) {
      let dateDay = 8-this.getFirstDay + day + (week === 1 ? 0 : week * 7 - 7)
      if (dateDay > this.dayInMonth) return ''
      return dateDay
    },
    clickDay(e) {
      if (e.target.innerHTML.trim().length === 0) return
      const month = parseInt(this.month) + 1
      this.date = `${ e.target.innerHTML.trim() }.${ (month.toString().length === 1) ? "0" + month : month }.${ this.year }`
      this.openCalendar()
      this.emitDate()
    },
    checkLengthYear() {
      if (this.year.length > 4) this.year = this.year.slice(0, -1)
    },
    setValue() { // установить значение поля для ввода
      if (this.type === 'datepicker' && this.value) {
        const d = this.value.split('.')
        this.year = d[2]
        this.month = d[1]
        this.date = `${ d[0] }.${ this.month }.${ this.year }`
      } else {
        this.inputData = !this.value ? '' : this.value
      }
    },
    emitDate() {
      this.$emit('on-input', this.date)
    }
  }
}
</script>

<style scoped>
  .datepicker {
    position: relative;
  }
  .ico-calendar {
    position: absolute;
    right: 10px;
    top: 50%;
    z-index: 10;
    transform: translate(0, -0.85em);
    cursor: pointer;
  }
  .calendar {
    position: absolute;
    left: 0px;
    top: 30px;
    width: 200px;
    box-shadow: 2px 2px 3px #000;
    background-color: white;
    opacity: 1;
    padding: 4px;
    z-index: 10;
  }
  .year {
    width: auto;
    text-align: center;
  }
  .year > input {
    width: 60px;
    text-align: center;
    border: none;
  }
  .month {
    width: auto;
    text-align: center;
    font-size: 0.75em;
  }
  .month > h5 {
    font-size: 1.5em;
  }
  input[type='button'] {
    border: none;
    background-color: white;
  }
  .left {
    float: left;
  }
  .right {
    float: right;
  }
  .info {
    color: teal;
  }
  span.day {
    width: 22px;
    height: 22px;
    text-align: center;
    line-height: 18px;
    margin: 2px;
    cursor: default;
  }
  div.day {
    border-bottom: orangered solid 1px;
  }
</style>
